import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { handlePageLoading } from "../../redux/authentication/actions";

const whitelistedRoutes = [
  "/user/creation",
  "/user/detail",
  "/user/vechile-onboarding",
  "/user/riders-registration",
  "/dealer/detail",
  "/dealer/create-branch",
  "/branch/detail",
  "/branch/update-branch",
  "/branch/create-testimonial",
  "/rides/member-detail",
  "/rides/create",
  "/rides/detail",
  "/rides/update",
  "/branch/apply-for-branch-create",
  "/rentals-edit",
  "/tours-edit",
  "/experiences-edit",
];

export default (ChildComponent) => {
  class AuthGuard extends PureComponent {
    componentWillMount() {}
    componentDidMount() {
      let { pathname } = this.props.location;
      if (whitelistedRoutes.includes(pathname)) {
        let payload = { loading: false };
        this.props.handlePageLoading(payload);
      }
    }

    componentWillReceiveProps(nextProps) {
      if (
        nextProps.location.pathname !== this.props.location.pathname &&
        nextProps.userPermissions.length !== 0
      ) {
        this.checkRoute(nextProps);
      }
      if (
        nextProps.userPermissions !== this.props.userPermissions &&
        nextProps.userPermissions.length !== 0
      ) {
        this.checkRoute(nextProps);
      }
    }

    async checkRoute(data) {
      let { userPermissions, location } = data;
      let payload = { loading: true };
      this.props.handlePageLoading(payload);

      if (whitelistedRoutes.indexOf(location.pathname) >= 0) {
        let payload = { loading: false };
        this.props.handlePageLoading(payload);
      } else {
        let routes = [];
        await userPermissions.map((item) => {
          return (routes = [...routes, ...item.pages]);
        });

        let [foundItem] = await routes.filter(
          (item) => item.route === location.pathname
        );
        if (foundItem) {
          let payload = { loading: false };
          this.props.handlePageLoading(payload);
        } else {
          // this.props.history.push("/");
        }
      }
    }

    toastError(message) {
      toast.error(message, {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        draggablePercent: 20,
      });
    }

    render() {
      let token = Cookies.get("refreshToken") || Cookies.get("RE_BU_CR");
      switch (token) {
        case null:
          return <Redirect to="/auth/login" />;
        case undefined:
          return <Redirect to="/auth/login" />;
        default:
          return <ChildComponent {...this.props} state={this.state} />;
      }
    }
  }

  function mapDispatchToProps(dispatch) {
    return {
      handlePageLoading: (payload) => {
        dispatch(handlePageLoading(payload));
      },
    };
  }

  function mapStateToProps(state) {
    return {
      token: state.Auth.token,
      userPermissions: state.Auth.userPermissions,
    };
  }

  return connect(mapStateToProps, mapDispatchToProps)(AuthGuard);
};
